import React from 'react';
import Switch from "react-switch";

class TsSwitchableBlock extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			displayBlock: this.props.checked || false,
		};

		this.handleDisplayBlock = this.handleDisplayBlock.bind(this);
    }
 
	handleDisplayBlock(checked) {
		this.setState({
			displayBlock: checked, 
		});
	}
    
	render () {
		// On instancie un indicateur du nombre de cartes
		const hasStateCards = Object.keys(this.props.cards).length > 0;

		return (
			<div className="tsSwitchableBlock">
				<label htmlFor={this.props.idLabel} className="man row pll prl">
					<div className="col txtmiddle w50p">
						<Switch
							onChange={this.handleDisplayBlock}
							checked={this.state.displayBlock}
							id={this.props.idLabel}
							uncheckedIcon={false}
							checkedIcon={false}
							height={18}
							width={34}
							handleDiameter={16}
							className="txtmiddle col"
							onColor={"#3cd823"}
							offColor={"#858383"}
						/>
					</div>
					<div className="txtmiddle col h6-like">
						{this.props.textLabel}
					</div>
				</label>

				{this.state.displayBlock && hasStateCards &&
					<div>
						{this.props.children}
					</div>
				} 
			</div>
		);
	}
}

export default TsSwitchableBlock;


// WEBPACK FOOTER //
// ./src/js/TsSwitchableBlock.jsx